/**
 *
 */
exportSettingService.$inject = ['httpRequest', '$uibModal']
export default function exportSettingService(httpRequest, $uibModal) {
  return function (id, config) {
    function save(obj) {
      httpRequest.post_saveUserCustomized({
        profileInfo: JSON.stringify(obj),
        profileType: id,
      })
    }

    $uibModal
      .open({
        template: getDialogTemplate(),
        backdrop: 'static',
        controller: [
          '$scope',
          'config',
          'id',
          '$uibModalInstance',
          'httpRequest',
          modalCtrl,
        ],
        openedClass: 'mod-modal mod-modal-lg mod-modal-big',
        resolve: {
          config() {
            return config
          },
          id() {
            return id
          },
        },
      })
      .result.then((data) => {
        // 点击确定才更新自定义配置
        save(data.config)
      })
  }
}

function getDialogTemplate() {
  return `
<div class="page-settablesyllable">
    <div class="modal-header clearfix">
        <h3 class="modal-title">导出字段设置</h3>
        <div class="modal-cancel close" ng-click="cancel()"><i class="icon iconfont icon-shanchu3"></i></div>
    </div>
    <div class="modal-body form-horizontal clearfix">
        <div class="table-subtitle">
            <h5>请勾选您需要导出的发票字段，未勾选的将不导出！</h5>
        </div>

        <!-- 主体信息+票据拆分-增值税发票主体字段信息 -->
        <div class="clearfix">
            <!-- 标题 -->
            <div class="export-sencod-title clearfix">
                <span>发票主体信息:</span>
                <label class="u-selfcheckbox j-selfcheckbox clearfix f-fr" ng-class="{'z-crt': selected}">
                    <input type="checkbox" ng-model="selected" ng-change="allChoose(1)" />
                    <span class="iconfontbox">
                        <i class="icon iconfont icon-gou"></i>
                    </span>
                    <span class="text">全选</span>
                </label>
            </div>
            <!-- 字段选择 -->
            <div ng-repeat="j in config.mainInfo" ng-show="j.label"
                class="col-xs-4 modal-row modal-row-setsyllableModal">
                <label class="u-selfcheckbox j-selfcheckbox clearfix" ng-class="{'z-crt': j.selected}">
                    <input type="checkbox" ng-model="j.selected" ng-change="changeChildChexbox(1)" />
                    <span class="iconfontbox">
                        <i class="icon iconfont icon-gou"></i>
                    </span>
                    <span class="text">{{ j.label}}</span>
                </label>
            </div>
        </div>

        <!-- 发票明细+票据拆分-增值税发票明细 -->
        <div class="clearfix">
            <!-- 标题 -->
            <div class="export-sencod-title clearfix" ng-show="config.detailInfo && config.detailInfo.length ">
                <span>发票明细信息:</span>
                <label class="u-selfcheckbox j-selfcheckbox clearfix f-fr" ng-class="{'z-crt': selected1}">
                    <input type="checkbox" ng-model="selected1" ng-change="allChoose(0)" />
                    <span class="iconfontbox">
                        <i class="icon iconfont icon-gou"></i>
                    </span>
                    <span class="text">全选</span>
                </label>
            </div>
            <!-- 字段选择 -->
            <div ng-repeat="j in config.detailInfo" ng-show="j.label"
                class="col-xs-4 modal-row modal-row-setsyllableModal">
                <label class="u-selfcheckbox j-selfcheckbox clearfix" ng-class="{'z-crt': j.selected}">
                    <input type="checkbox" ng-model="j.selected" ng-change="changeChildChexbox(0)" />
                    <span class="iconfontbox">
                        <i class="icon iconfont icon-gou"></i>
                    </span>
                    <span class="text">{{ j.label}}</span>
                </label>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-default btn-md" type="button" ng-click="cancel()">取消</button>
        <button class="btn btn-primary btn-md" type="button" ng-click="ok()">确定</button>
    </div>
</div>   
    `
}

function modalCtrl($scope, config, id, $uibModalInstance, httpRequest) {
  // 点击确定才生效 深克隆创建隔离作用域
  const isolatedConfig = []
  // config.forEach((config) => {
  isolatedConfig.push($.extend(true, {}, config))
  // })
  $scope.config = isolatedConfig[0]
  console.log($scope.billTypeTitle)
  if (id && config) {
    httpRequest.get_getUserCustomized(id).then((res) => {
      if (res.data.value) {
        const savedConfig = JSON.parse(res.data.value)
        //     const savedVersion = savedConfig.version || 0
        //     if (savedVersion === config.version) {
        //         $scope.config = savedConfig
        //     }
        // }
        savedConfig.mainInfo &&
          savedConfig.mainInfo.forEach((i) => {
            $scope.config.mainInfo.forEach((o) => {
              if (i.label == o.label) o.selected = i.selected
            })
          })
        savedConfig.detailInfo &&
          savedConfig.detailInfo.forEach((i) => {
            $scope.config.detailInfo.forEach((o) => {
              if (i.label == o.label) o.selected = i.selected
            })
          })
        savedConfig.commonMainInfo &&
          savedConfig.commonMainInfo.forEach((i) => {
            $scope.config.commonMainInfo.forEach((o) => {
              if (i.label == o.label) o.selected = i.selected
            })
          })
        $scope.config.mainInfo && $scope.changeChildChexbox(1)
        $scope.config.detailInfo && $scope.changeChildChexbox(0)
        $scope.config.commonMainInfo && $scope.changeChildChexbox(2)
      }
    })
  }

  // 关闭
  $scope.cancel = function cancel() {
    $uibModalInstance.dismiss('cancel')
  }
  // 确定
  $scope.ok = function ok() {
    $uibModalInstance.close({
      config: $scope.config,
    })
  }
  $scope.changeChildChexbox = function (v) {
    let count = 0
    if (v == 1) {
      $scope.config.mainInfo.forEach((element) => {
        if (element.selected) count++
      })
      if (count == $scope.config.mainInfo.length) {
        $scope.selected = true
      } else {
        $scope.selected = false
      }
    } else if (v == 0) {
      $scope.config.detailInfo.forEach((element) => {
        if (element.selected) count++
      })
      if (count == $scope.config.detailInfo.length) {
        $scope.selected1 = true
      } else {
        $scope.selected1 = false
      }
    }
  }
  $scope.allChoose = function allChoose(v) {
    if (v == 1) {
      $scope.config.mainInfo.forEach((element) => {
        element.selected = $scope.selected
      })
    } else if (v == 0) {
      $scope.config.detailInfo.forEach((item) => {
        item.selected = $scope.selected1
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/services/exportSettingService.js